import { defaultPageInfo } from '@/common/constants/ConstCode';
import { isEmpty } from '@/common/utils/Util';

export default {
  setList: (state, list = []) => {
    state.list = list;
  },

  setDetail: (state, detail = null) => {
    state.detail = detail;
  },

  setHasItem: (state, hasItem = false) => {
    state.hasItem = hasItem;
  },

  setGalleryItemList: (state, list = []) => {
    state.galleryItemList = list;
  },

  setPreViewImage: (state, image = {}) => {
    state.preViewImage = image;
  },

  setSelectedImage: (state, image = {}) => {
    if (isEmpty(image)) {
      state.selectedImage = null;
    } else {
      state.selectedImage = image;
    }
  }
};
